import styled from 'styled-components';
import AutoComplete from '../auto-complete/AutoComplete';
import TextField from '../text-field/TextField';
import Hyperlink from '../hyperlink/HyperLink';
import { RowBase, RowLabel, RowValue } from '../../views/task-view/task-details-view2/components/TextRow';
import { StandardInstruction, standardInstructions, standardInstructionsUrl } from '../../models/StandardInstructions';

interface Props {
  label: string;
  value?: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
}

const StandardInstructionsField = (props: Props) => {
  const { label, value, onChange, readOnly, disabled, required, error } = props;

  const selected = standardInstructions.find((i) => i.title === value) ?? null;

  return (
    <Container>
      {readOnly ? (
        <RowBase>
          <RowLabel>{label}</RowLabel>
          <RowValue>{value}</RowValue>
        </RowBase>
      ) : (
        <AutoComplete<StandardInstruction>
          options={standardInstructions}
          groupBy={(option) => option.section}
          getOptionLabel={(option) => option.title}
          isOptionEqualToValue={(option, val) => option.title === val.title}
          value={selected}
          disabled={disabled}
          onChange={(_, newValue) => onChange && onChange((newValue as StandardInstruction | null)?.title ?? '')}
          renderInput={(params) => <TextField {...params} label={label} required={required} error={error} />}
          fullWidth
        />
      )}
      <Hyperlink link={standardInstructionsUrl} label="Se alle standardinstrukser" />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export default StandardInstructionsField;
